var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.css },
    [
      _vm.version === "1_0"
        ? _c("hero-homepage-gallery-v1", {
            attrs: {
              "desktop-sizes": _vm.desktopSizes,
              debug: _vm.debug,
              translations: _vm.translations,
              items: _vm.items,
              "mobile-sizes": _vm.mobileSizes,
            },
            on: { update: _vm.updateOpacity },
          })
        : _c("hero-homepage-gallery-v2", {
            attrs: {
              "desktop-sizes": _vm.desktopSizes,
              debug: _vm.debug,
              translations: _vm.translations,
              items: _vm.items,
              "mobile-sizes": _vm.mobileSizes,
              autoplay: _vm.autoplay,
            },
            on: { update: _vm.updateOpacity },
          }),
      _vm._v(" "),
      _c("hero-homepage-debug", {
        attrs: {
          buttons: _vm.debugButtons,
          debug: _vm.debug,
          "debug-enabled": _vm.debugEnabled,
          items: _vm.debugItems,
        },
        on: { click: _vm.toggleDebug },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }